var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHifzESurah(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 272.394,
    height: 221.413,
    viewBox: "0 0 272.394 221.413",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7952",
    "data-name": "Group 7952",
    transform: "translate(-159.233 -165.742)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39340",
    "data-name": "Path 39340",
    d: "M205.115,185.119,168.1,214.944v12.381l21.474-17.89,18.172,20.013L168.1,265.55v16.484l86.366-81.608-49.348-15.308",
    transform: "translate(40.966 101.64)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39341",
    "data-name": "Path 39341",
    d: "M295.43,302.026,161.08,260.461,187.7,167.708l107.732,39.72Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39342",
    "data-name": "Path 39342",
    d: "M230.076,185.119l37.018,29.825v12.381l-20.549-17.293L229.2,228.663l37.9,36.887v16.484l-86.366-81.608,49.348-15.308",
    transform: "translate(114.702 101.64)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39343",
    "data-name": "Path 39343",
    d: "M180.728,302.026l134.35-41.565L288.46,167.708l-107.732,39.72Z",
    transform: "translate(114.702 0)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHifzESurah);
export default __webpack_public_path__ + "static/media/Hifz_e_Surah.cac26fd6331256ad0d41fc0a5f022210.svg";
export { ForwardRef as ReactComponent };